import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ICompanyLogoData } from '../interfaces/company-logo-data.interface';

@Component({
  selector: 'app-company-logo-preview',
  templateUrl: './company-logo-preview.component.html',
  styleUrl: './company-logo-preview.component.scss',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ]
})
export class CompanyLogoPreviewComponent {
  constructor(
    public dialogRef: MatDialogRef<CompanyLogoPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICompanyLogoData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}